/* eslint-disable import/prefer-default-export */
/* eslint-disable no-useless-escape */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';


import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Nav from 'react-bootstrap/Nav';


import { DatetimePicker, TimePicker } from '@appblocks/frontend/client/Components/DeviceDashboard/TimeComponents';
import {
    CMD_VARIABLE,
    CMD_TABLE,
    CMD_SYSTEM,
    CMD_VARIABLE_ACTION,
    CMD_TABLE_ACTION,
    CMD_SYSTEM_ACTION,
    SYSTEM_COMMANDS,
} from '@appblocks/frontend/client/Components/DeviceDashboard/constants';

import SyncStatus from '@appblocks/frontend/cloudclient/Components/SyncStatus';
import { format32bitFloat } from '@appblocks/frontend/client/Components/DeviceDashboard/utils';

export function DeviceGroupSettingField({
    setting,
    onChange,
    value,
    disabled,
}) {
    const [errorMessage, setErrorMessage] = useState('');
    const [invalid, setInvalid] = useState(false);

    useEffect(() => {
        const validatedSetting = validateSetting({
            ...setting,
            VALUE: value,
        });
        setInvalid(validatedSetting.invalid);
        setErrorMessage(validatedSetting.errorMessage);
    }, [value]);

    const handleChange = (value) => {
        const newSetting = {
            ...setting,
            VALUE: value,
        };
        const validatedSetting = validateSetting(newSetting);
        onChange(validatedSetting, {
            target: {
                value,
            },
        });
    };

    return (
        <SettingField
            setting={{
                ...setting,
                errorMessage,
                invalid,
                disabled,
                VALUE: value,
            }}
            onChange={handleChange}
        />
    );
}


/* FRONTEND_START_MARKER */

function validateSetting(setting) {
    const {
        variable: settingName,
        min,
        max,
        disabled,
        control,
        dataType,
        VALUE: settingValue,
    } = setting;
    let errorMessage = '';
    let invalid = false;
    // $(`#setting-container-${setting.I} .invalid-feedback`).text('');
    let itemValid = true;
    let message = '';
    switch (dataType) {
        case 'INT':
            if ((min && min !== '' && Number(settingValue) < Number(min))
                || (max && max !== '' && Number(settingValue) > Number(max))) {
                message = `Value must be between ${min} and ${max}`;
                itemValid = false;
                if (min === '' && max) {
                    message = `Value must be no more than ${max}`;
                }
                if (min && max === '') {
                    message = `Value must be at least ${min}`;
                }
            }
            if (settingValue === '' || Number.isNaN(Number(settingValue))) {
                itemValid = false;
                message = 'Value must be a number';
            }
            break;
        case 'STRING':
            if ((min && min !== '' && settingValue !== undefined && settingValue.length < Number(min))
                || (max && max !== '' && settingValue !== undefined && settingValue.length > Number(max))) {
                itemValid = false;
                message = `Value must be between ${min} and ${max} characters`;
                if (min === '' && max) {
                    message = `Value must be no more than ${max} characters`;
                }
                if (min && max === '') {
                    message = `Value must be at least ${min} characters`;
                }
            }
            break;
        default:
            break;
    }
    switch (control) {
        case 'IPCTRL':
            itemValid = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.exec(settingValue) !== null;
            message = 'invalid format';
            break;
        case 'ETHERNETCTRL':
            itemValid = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/.exec(settingValue) !== null;
            message = 'invalid format';
            break;
        default:

            break;
    }
    if (!itemValid) {
        invalid = true;
        errorMessage = message;
    } else {
        errorMessage = '';
    }
    return {
        ...setting,
        invalid,
        errorMessage,
    };
}

class Settings extends React.Component {
    constructor(props) {
        super(props);

        const groups = [];
        const settings = [];
        this.settingsIndex = 0;
        // if (props.server !== undefined) {
        //     API_URL_BASE = 'props.server';
        // }

        this.state = {
            groups,
            settings,
            activeGroup: undefined,
            settingsIndex: 0,
            commandQueue: [],
            showPasswords: [],
            loaded: false,
            saving: false,
        };

        this.save = this.save.bind(this);
        this.cancel = this.cancel.bind(this);
        this.refreshSettings = this.refreshSettings.bind(this);
        this.changeTab = this.changeTab.bind(this);
        this.toggleShowPassword = this.toggleShowPassword.bind(this);
    }

    componentDidMount() {
        this.initSettings();
    }

    setLoaded() {
        this.setState({
            loaded: true,
        });
    }

    getSetting(settingId) {
        for (let i = 0; i < this.state.settings.length; i++) {
            if (this.state.settings[i].variable === settingId) {
                return this.state.settings[i];
            }
        }

        return undefined;
    }

    processCommandQueue() {
        if (this.state.commandQueue.length > 0) {
            const { commandQueue } = this.state;
            const command = commandQueue.shift();
            this.setState({
                commandQueue,
            }, () => this.sendCommand(command.trim()));
        }
    }

    sendCommand(cmd) {
        this.props.runCommand(CMD_SYSTEM, CMD_SYSTEM_ACTION.SEND_COMMAND, {
            cmd,
        }).then((data) => {
            this.processCommand(data);
        });
    }

    processCommand(data) {
        let cursor = 0;
        const max = data.length;
        const { settings } = this.state;
        let { settingsIndex } = this.state;
        while (cursor < data.length) {
            let char = data[cursor++];
            if (char === '\x02') {
                let msg = '';
                // parse message
                char = data[cursor++];
                const status = char;
                if (char === 'A') {
                    let index = 0;
                    while (char !== '\r' && index < 100) {
                        char = data[cursor++];
                        msg += char;
                        index++;
                    }
                }
                msg = msg.trim();
                const setting = settings[settingsIndex];
                setting.loading = false;
                setting.disabled = false;
                if (msg.length === 0) {
                    switch (status.toUpperCase()) {
                        case 'A':
                            // ok has reply
                            break;
                        case 'R':
                            // reject
                            break;
                        case 'C':
                            // error

                            break;
                        case 'F':
                            // failed
                            break;
                        default:

                            break;
                    }
                } else {
                    const settingValue = msg;
                    settings[settingsIndex].VALUE = settingValue;
                    settings[settingsIndex].loading = false;
                    settings[settingsIndex].disabled = false;
                }

                settingsIndex++;
            }
        }
        this.setState({
            settingsIndex,
            settings,
        }, () => {
            this.processCommandQueue();
            this.updateConstraints();
        });
    }

    updateConstraints() {
        const { settings } = this.state;
        for (let i = 0; i < settings.length; i++) {
            const item = settings[i];
            if (item.type !== 'group') {
                // whether to show the setting control
                if (item.S !== undefined) {
                    let finalState = this.evaluateExpression(item.S);
                    finalState = finalState.toString().replaceAll('\"', '');
                    switch (finalState) {
                        // Relevant
                        case 'e':
                            item.disabled = false;
                            break;
                        // Irrelevant
                        case 'i':
                            item.disabled = true;
                            break;
                        // Modifiable
                        case 'a':
                            item.disabled = false;
                            break;
                        case 'h':
                            item.hidden = true;
                            break;
                        default:
                            break;
                    }
                }
            }
        }

        this.setState({
            settings,
        });
    }

    evaluateExpression(expression) {
        let result = false;
        // eslint-disable-next-line no-eval
        const geval = eval;
        const { settings } = this.state;
        try {
            for (let i = 0; i < settings.length; i++) {
                const item = settings[i];
                if (item.type === 'group') {
                    continue;
                }
                let val = this.getSetting(item.variable).VALUE;
                if (val !== undefined && val.length === 0) {
                    switch (item.dataType) {
                        case 'INT':
                        case 'DECIMAL':
                        case 'DWORD':
                        case 'WORD':
                        case 'SHORT':
                        case 'BYTE':
                            val = 0;
                            break;
                        case 'STRING':
                            val = '\"\"';
                            break;
                        default:
                            break;
                    }
                    if (item.dataType === 'INT') {
                        val = 0;
                    } else if (item.dataType === 'STRING') {
                        val = '\"\"';
                    }
                } else {
                    switch (item.dataType) {
                        case 'STRING':
                            val = `\"${val}\"`;
                            break;
                        default:
                            break;
                    }
                }
                const str = `var ${item.variable}=${val}`;
                geval(str);
            }
            result = geval(expression);
        } catch (ex) {
            console.log(ex);
        }

        return result;
    }

    cancel() {
        this.setState({
            commandQueue: [],
        }, () => this.processCommandQueue());
    }

    save(e) {
        if (e) {
            e.preventDefault();
        }
        if (this.state.settings.some(setting => setting.invalid && setting.groupId === this.state.activeGroup)) {
            return;
        }
        const { settings, activeGroup } = this.state;
        const settingsToSave = [];
        for (let i = 0; i < settings.length; i++) {
            const setting = settings[i];
            if (setting.groupId !== activeGroup) {
                continue;
            }
            setting.disabled = true;
            if (setting.pendingChange) {
                if (setting.dataType === 'INT') {
                    setting.VALUE = Number(format32bitFloat(setting.VALUE, 4)).toString();
                }
                settingsToSave.push(setting);
            }
        }
        this.setState({
            saving: true,
            settings,
        }, async () => {
            for (let i = 0; i < settingsToSave.length; i++) {
                const setting = settingsToSave[i];
                let errorCount = 0;
                while (errorCount < 3) {
                    try {
                        let value = setting.VALUE;
                        if (setting.dataType === 'INT'
                        ) {
                            value = Number(format32bitFloat(value, 4));
                        }
                        // eslint-disable-next-line no-await-in-loop
                        await this.props.runCommand(CMD_VARIABLE, CMD_VARIABLE_ACTION.SET, {
                            variable: setting.variable,
                            value,
                        });
                        break;
                    } catch (ex) {
                        console.log(ex);
                        errorCount++;
                    }
                }
            }
            this.setState({
                saving: false,
            }, () => {
                this.refreshSettings();
            });
        });
    }

    refreshSettings() {
        const { settings, activeGroup } = this.state;
        for (let i = 0; i < settings.length; i++) {
            const setting = settings[i];
            setting.pendingChange = false;
            if (setting.groupId !== activeGroup) {
                continue;
            }
            setting.loading = true;
            setting.isNotSynced = false;
            setting.disabled = true;
        }
        this.setState({
            settings,
        }, async () => {
            try {
                const variables = [];
                for (let i = 0; i < settings.length; i++) {
                    const setting = settings[i];
                    if (setting.groupId !== activeGroup) {
                        continue;
                    }
                    variables.push(setting.variable);
                }
                const result = await this.props.runCommand(CMD_VARIABLE, CMD_VARIABLE_ACTION.GET_WIDGET_VARIABLES, {});
                for (let i = 0; i < settings.length; i++) {
                    const setting = settings[i];
                    if (setting.groupId !== activeGroup) {
                        continue;
                    }
                    setting.VALUE = result[setting.variable];
                }
            } catch (ex) {
                console.log(ex);
            }
            this.setState({
                settings: settings.map(setting => ({
                    ...setting,
                    invalid: false,
                    errorMessage: '',
                    loading: false,
                    disabled: false,
                })),
            }, () => {
                this.updateConstraints();
            });
        });
    }

    initSettings() {
        const groups = [];
        const settings = [];
        let activeGroup;
        const { settings: propsSettings } = this.props;
        for (let i = 0; i < propsSettings.length; i++) {
            const setting = propsSettings[i];
            if (setting.type === 'group') {
                groups.push({
                    id: setting.id,
                    name: setting.name,
                });
            } else {
                settings.push({
                    ...setting,
                    VALUE: '',
                    pendingChange: false,
                });
            }
        }
        if (groups.length > 0) {
            activeGroup = groups[0].id;
        }
        this.setState({
            settings,
            groups,
            activeGroup,
        }, () => {
            this.refreshSettings();
            this.setLoaded();
        });
    }

    toggleShowPassword(settingId) {
        const { showPasswords } = this.state;
        if (!showPasswords.includes(settingId)) {
            showPasswords.push(settingId);
        } else {
            showPasswords.splice(showPasswords.indexOf(settingId), 1);
        }
        this.setState({
            showPasswords,
        });
    }

    formChange(setting, value) {
        const { settings, loaded, activeGroup } = this.state;
        for (let i = 0; i < settings.length; i++) {
            if (settings[i].variable === setting.variable && settings[i].groupId === activeGroup) {
                if (loaded && settings[i].VALUE !== value) {
                    settings[i].pendingChange = true;
                }
                settings[i].VALUE = value;
                settings[i] = validateSetting(settings[i]);
            }
        }
        this.setState({
            settings,
        }, () => {
            this.updateConstraints();
        });
    }

    changeTab(group) {
        const { settings } = this.state;
        for (let i = 0; i < settings.length; i++) {
            if (settings[i].pendingChange) {
                if (!window.confirm('Unsaved changes will be lost. Continue?')) {
                    return;
                }
            }
        }

        // Clear validation state for all settings when switching tabs
        for (let i = 0; i < settings.length; i++) {
            settings[i].invalid = false;
            settings[i].errorMessage = '';
        }

        this.setState({
            activeGroup: group,
            settings,
        }, () => {
            this.refreshSettings();
        });
    }

    renderSettings() {
        if (this.state.activeGroup !== undefined) {
            if (this.state.settings.length === 0) {
                return (
                    <div className="d-flex justify-content-center align-items-center">
                        <h4 className="fst-italic">
                            {
                                this.props.editPage ? 'No setting added yet' : 'No settings'
                            }
                        </h4>
                    </div>
                );
            }
            return (this.state.settings.map((item, i) => {
                if (item.groupId !== this.state.activeGroup) {
                    return null;
                }
                const fieldControl = (
                    <SettingField
                        setting={item}
                        onChange={value => this.formChange(item, value)}
                        showPasswords={this.state.showPasswords}
                        toggleShowPassword={this.toggleShowPassword}
                    />
                );

                let visibility = 'visible';
                if (item.hidden) {
                    visibility = 'none';
                }
                const element = (
                    <Form.Group as={Row} visibility={visibility} className="mt-3 px-1" key={i}>
                        <div className="d-flex flow-row">
                            <label className="form-label">{item.name}</label>
                            {
                                item.isNotSynced && (
                                    <>
                                        &nbsp;
                                        <SyncStatus
                                            device={this.props.device}
                                            propKeys={['variables']}
                                            cancel={(variable) => {
                                                this.props.runCommand(CMD_VARIABLE, CMD_VARIABLE_ACTION.CANCEL_CHANGES, {
                                                    variable,
                                                });
                                                this.refreshSettings();
                                            }}
                                        />
                                    </>
                                )
                            }
                        </div>
                        <Col className="input-group" sm={9} data-testid={`input-group-${item.name}`}>
                            {fieldControl}
                            {item.loading || this.state.saving
                                ? (
                                    <span className="input-group-text h-100">
                                        <Spinner animation="border" size="sm" />
                                    </span>
                                )
                                : null
                            }
                        </Col>
                    </Form.Group>
                );

                return element;
            }));
        }
    }

    render() {
        return (
            <div>
                <div
                    className="d-flex align-items-center"
                >
                    <h2>Settings</h2>
                    {
                        this.props.editPage && (
                            <Button
                                onClick={() => this.props.editPage('GROUPS')}
                                className="ms-auto"
                            >
                                Edit
                            </Button>
                        )
                    }
                    {
                        this.props.device && (
                            <>
                                &nbsp;
                                <SyncStatus
                                    device={this.props.device}
                                    propKeys={['variables']}
                                    cancel={(variable) => {
                                        this.props.runCommand(CMD_VARIABLE, CMD_VARIABLE_ACTION.CANCEL_CHANGES, {
                                            variable,
                                        });
                                        this.refreshSettings();
                                    }}
                                />
                            </>
                        )
                    }
                </div>
                {
                    this.state.groups.length > 0 ? (
                        <>
                            <Nav variant="tabs" activeKey={this.state.activeGroup} onSelect={this.changeTab}>
                                {this.state.groups.map((group, i) => (
                                    <Nav.Item
                                        key={i}
                                    >
                                        <Nav.Link eventKey={group.id}>{group.name}</Nav.Link>
                                    </Nav.Item>
                                ))}
                            </Nav>
                            <div
                                className="bg-white"
                                style={{
                                    padding: '15px',
                                    border: '1px solid #dee2e6',
                                    borderTop: '0',
                                }}
                            >
                                <Form onSubmit={(e) => { this.save(e); return false; }}>
                                    {this.renderSettings()}
                                </Form>
                                <Row>
                                    <Col>
                                        <br />
                                        {this.state.commandQueue.length === 0
                                            ? (
                                                <Button
                                                    onClick={this.save}
                                                    variant="primary"
                                                    disabled={
                                                        this.state.settings.some(setting => setting.invalid && setting.groupId === this.state.activeGroup)
                                                    }
                                                >
                                                    Save
                                                </Button>
                                            )
                                            : null}
                                        &nbsp;
                                        {this.state.commandQueue.length > 0
                                            ? <Button onClick={this.cancel} variant="secondary">Cancel</Button>
                                            : null}
                                        &nbsp;
                                        {this.state.commandQueue.length === 0
                                            ? <Button onClick={this.refreshSettings} variant="secondary">Refresh</Button>
                                            : null}
                                        &nbsp;
                                    </Col>
                                </Row>
                            </div>
                        </>
                    ) : (
                        <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ height: '200px' }}
                        >
                            <h4 className="fst-italic">
                                {
                                    this.props.editPage ? 'No settings group added yet' : 'No settings group'
                                }
                            </h4>
                        </div>
                    )
                }
            </div>
        );
    }
}

class SettingField extends React.Component {
    renderDropdown(item) {
        const options = [];
        for (let j = 0; j < item.options.length; j++) {
            options.push(
                <option key={j} value={item.options[j].VALUE}>{item.options[j].LABEL}</option>,
            );
        }
        return (
            <Form.Control
                as="select"
                value={item.VALUE}
                className={`form-control ${item.errorMessage !== '' ? ' is-invalid' : ''} ${item.isNotSynced ? 'opacity-75' : ''}`}
                onChange={e => this.props.onChange(e.target.value)}
                disabled={item.disabled || item.readonly === '1' || this.props.disabled}
            >
                {options.map(option => option)}
            </Form.Control>
        );
    }

    render() {
        const item = {
            ...this.props.setting,
        };
        let fieldControl = '';
        let showPassword = false;
        const showPasswords = this.props.showPasswords || [];
        switch (item.control) {
            case 'EDIT':
                switch (item.dataType) {
                    case 'DATETIME':
                        fieldControl = (
                            <DatetimePicker
                                className={`${item.errorMessage !== '' ? ' is-invalid' : ''} ${item.isNotSynced ? 'opacity-75' : ''}`}
                                disabled={item.disabled || item.readonly === '1' || this.props.disabled}
                                edit
                                time={Number(item.VALUE)}
                                handleChange={(value) => {
                                    this.props.onChange(value.toString());
                                }}
                            />
                        );
                        break;
                    case 'TIME':
                        fieldControl = (
                            <TimePicker
                                edit
                                className={`${item.errorMessage !== '' ? ' is-invalid' : ''} ${item.isNotSynced ? 'opacity-75' : ''}`}
                                disabled={item.disabled || item.readonly === '1' || this.props.disabled}
                                time={Number(item.VALUE)}
                                handleChange={(value) => {
                                    this.props.onChange(value.toString());
                                }}
                            />
                        );
                        break;
                    default:
                        fieldControl = (
                            <input
                                type="text"
                                className={`form-control ${item.errorMessage !== '' ? ' is-invalid' : ''} ${item.isNotSynced ? 'opacity-75' : ''}`}
                                placeholder={item.name}
                                onChange={e => this.props.onChange(e.target.value)}
                                disabled={item.disabled || item.readonly === '1' || this.props.disabled}
                                value={item.VALUE === null || item.VALUE === undefined ? '' : item.VALUE}
                            />
                        );
                        break;
                }
                break;
            case 'ETHERNETCTRL':
            case 'IPCTRL':
                fieldControl = (
                    <input
                        type="text"
                        className={`form-control ${item.errorMessage !== '' ? ' is-invalid' : ''} ${item.isNotSynced ? 'opacity-75' : ''}`}
                        value={item.VALUE}
                        placeholder={item.name}
                        onChange={e => this.props.onChange(e.target.value)}
                        disabled={item.disabled || item.readonly === '1' || this.props.disabled}
                    />
                );
                break;
            case 'PASSWORD':
                showPassword = showPasswords.includes(item.variable);
                fieldControl = (
                    <>
                        <input
                            type={showPassword ? 'text' : 'password'}
                            className={`form-control ${item.errorMessage !== '' ? ' is-invalid' : ''} ${item.isNotSynced ? 'opacity-75' : ''}`}
                            placeholder={item.name}
                            value={item.VALUE}
                            onChange={e => this.props.onChange(e.target.value)}
                            disabled={item.disabled || item.readonly === '1' || this.props.disabled}
                        />
                        <div className="input-group-append">
                            <button type="button" className="btn btn-outline-secondary" onClick={() => this.props.toggleShowPassword(item.variable)}>
                                {showPassword ? 'Hide' : 'Show'}
                            </button>
                        </div>
                    </>
                );
                break;
            case 'STATIC':
                if (item.options !== undefined) {
                    fieldControl = this.renderDropdown(item);
                }
                break;
            default:
                fieldControl = item.control;
                break;
        }

        return (
            <>
                {fieldControl}
                {!item.loading && (
                    <div className="invalid-feedback">
                        {item.errorMessage}
                    </div>
                )}
            </>
        );
    }
}

export default Settings;
export { SettingField };
